document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.modal .embed').forEach((elem) => {
    let modal = elem.closest('.modal');
    modal.addEventListener('hidden.bs.modal', (evt) => {
      evt.currentTarget.querySelector('.embed').innerHTML = '';
      evt.currentTarget.querySelector('.embed').innerHTML = evt.currentTarget.querySelector('.embed-cache').innerHTML
    })
  })

  document.querySelectorAll('.modal iframe').forEach((elem) => {
    let modal = elem.closest('.modal');
    modal.addEventListener('hidden.bs.modal', (evt) => {
      // resets the iframe on close
      evt.currentTarget.querySelector('iframe').src = evt.currentTarget.querySelector('iframe').src;
    });
  })

  // If a video modal trigger button is clicked, set the modal's iframe src from the trigger's data attribute
  document.querySelectorAll('[data-bs-toggle="modal"][data-bs-target="#video-modal"]').forEach((elem) => {
    let modal = document.getElementById('video-modal');
    let iframeSrc = elem.dataset.iframeSrc;

    if (modal && iframeSrc) {
      elem.addEventListener('click', (event) => {
        let modalIframes = modal.querySelectorAll('iframe');
        modalIframes.forEach((modalIframe) => {
          modalIframe.src = iframeSrc;
        });
      });
    }
  })
})
